export const triggerAdvanceCashierEvent = (data) => {
    const event = new CustomEvent('trigger_advance_cashier_event', {
        detail: data,
    })
    window.dispatchEvent(event)
}
